import { render, staticRenderFns } from "./CreditRiskView.vue?vue&type=template&id=0ea265ea&scoped=true&"
import script from "./CreditRiskView.vue?vue&type=script&lang=js&"
export * from "./CreditRiskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea265ea",
  null
  
)

export default component.exports